import * as React from "react";

import { UitkLink } from "@egds/react-core/link";
import { UitkIcon } from "@egds/react-core/icons";
import { UitkText } from "@egds/react-core/text";
import { UitkLayoutFlex } from "@egds/react-core/layout-flex";

import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { iconMap } from "../CrossLOBLinks";

import { LinkProps, IconMap } from "../typings";

const Link = (props: LinkProps) => {
  const { link } = props;
  const { icon, url, text, subtitle } = link;

  const iconName = iconMap[icon as keyof IconMap];
  if (!iconName) {
    return null;
  }

  return (
    <UitkLink>
      <TrackedLink href={url} rfrr={icon} moduleName="CrossLOBLinks">
        <UitkLayoutFlex space="one">
          <UitkIcon name={iconName} />

          <UitkLayoutFlex direction="column">
            <div>{text}</div>
            {Boolean(subtitle) && (
              <UitkText size={200} className="subtitle">
                {subtitle}
              </UitkText>
            )}
          </UitkLayoutFlex>
        </UitkLayoutFlex>
      </TrackedLink>
    </UitkLink>
  );
};

export default Link;
